import styled from "@emotion/styled";

export const CustomQuoteCommentsFlyoutContainer = styled("div")(({ theme }) => ({
	width: "375px",
	height: "100vh",
	display: "flex",
	flexDirection: "column",
	[theme.breakpoints.down("sm")]: {
		width: "100vw"
	}
}));

export const CustomQuoteCommentsFlyoutHeader = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	margin: `${theme.project.layout.gutters.large}px ${theme.project.layout.gutters.large}px 0px`
}));

export const CustomQuoteCommentsFlyoutFooter = styled("div")(({ theme }) => ({
	margin: `0px ${theme.project.layout.gutters.large}px ${theme.project.layout.gutters.large}px`,
	Button: {
		margin: `${theme.project.layout.gutters.small}px 0px`,
		svg: {
			marginBottom: "3px"
		}
	}
}));

export const CustomQuoteCommentsFlyoutTitle = styled("div")(({ theme }) => ({
	span: {
		...theme.project.typography.heading.h5
	}
}));

export const CommentsInfo = styled("div")(({ theme }) => ({
	...theme.project.typography.caption,
	margin: `${theme.project.layout.gutters.large}px`,
	span: {
		fontWeight: 600
	}
}));

export const CustomQuoteCommentsFlyoutContent = styled("div")(({ theme }) => ({
	flex: 1,
	display: "flex",
	flexDirection: "column",
	overflow: "hidden"
}));

export const CommentsSection = styled("div")(({ theme }) => ({
	border: theme.project.borders.presets.thinOutline,
	borderRadius: `${theme.project.borders.radius.small}px`,
	display: "flex",
	flex: 1,
	flexDirection: "column",
	margin: `0px ${theme.project.layout.gutters.large}px`,
	overflow: "auto"
}));

export const CommentsSectionHeader = styled("div")(({ theme }) => ({
	margin: `${theme.project.layout.gutters.small}px ${theme.project.layout.gutters.small}px`,
	span: {
		...theme.project.typography.body.body2,
		color: theme.project.colors.fontColors.secondary
	}
}));

export const CommentCardContainer = styled("div")(({ theme }) => ({
	margin: `${theme.project.layout.gutters.small}px`,
	"&:last-child": {
		marginBottom: 0
	}
}));

export const CommentCardHeader = styled("div")(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary
}));

export const Comment = styled("div")(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main,
	marginBottom: `${theme.project.layout.gutters.small}px`,
	span: {
		fontWeight: 600
	}
}));

export const CommentAttachment = styled("div")(({ theme }) => ({
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.selected,
	color: theme.project.colors.fontColors.secondary,
	display: "flex",
	gap: theme.project.layout.gap.small,
	justifyContent: "space-between",
	padding: theme.project.layout.gutters.small,
	".download-icon": {
		color: theme.project.colors.primaryColors.main
	},
	"> div": {
		display: "flex",
		alignItems: "center",
		gap: "8px"
	}
}));

export const CommentAttachmentInfo = styled("div")(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	padding: `0 ${theme.project.layout.gutters.small}`,
	"> p": {
		margin: 0
	}
}));

export const EmptyCommentsPlaceholder = styled("div")(({ theme }) => ({
	margin: `${theme.project.layout.gutters.small}px ${theme.project.layout.gutters.small}px`,
	span: {
		...theme.project.typography.body.body2,
		color: theme.project.colors.backgroundColors.disabled
	}
}));
